import config from '@/data/config'
const { getLsItem, setLsItem } = require('@kznjunk/window-storages')()

export { getLanguage, setLanguage }

function getLanguage() {
    const storedLang = getLsItem('language')
    const isGoodStoredLang = config.authorizedLanguage.includes(storedLang)

    const navLang = navigator.language
    const isGoodNavLang = config.authorizedLanguage.includes(navLang)

    if (!isGoodStoredLang && !isGoodNavLang) {
        return 'en'
    }

    if (isGoodStoredLang) {
        return storedLang
    }

    if (isGoodNavLang) {
        setLsItem('language', navLang)
        return navLang
    }

    return 'en'
}

function setLanguage(lang) {
    setLsItem('language', lang)

    return lang
}
